<template>
  <div class="flow-wk" v-loading="loading">
    <el-menu
      :default-active="activeIndex"
      class="el-menu-demo"
      mode="horizontal"
      :router="true"
      @select="goPage"
    >
      <el-menu-item index="/workplace">工作台</el-menu-item>
      <el-submenu index="2">
        <template slot="title">流程中心</template>
        <el-menu-item index="/myWork">我的待办</el-menu-item>
        <el-menu-item index="/flow?type=2">我发起的</el-menu-item>
        <el-menu-item index="/flow?type=3">我处理的</el-menu-item>
        <el-menu-item index="/flow?type=4">抄送我的</el-menu-item>
      </el-submenu>
      <el-menu-item index="3" disabled>|</el-menu-item>
      <el-menu-item index="/createFlow">发起新流程</el-menu-item>
    </el-menu>
    <GlobalSearch
      ref="child"
      :size="queryParams.size"
      :page="queryParams.page"
      :totalCount.sync="totalCount"
      :searchData.sync="searchData"
      :loading.sync="loading"
      @getStatus="getStatus"
      :searchValue="searchValue"
    />
    <div class="params-panel">
      <div class="flow-title">
        <span v-if="type == '2'">我发起的</span>
        <span v-else-if="type == '3'">我处理的</span>
        <span v-else-if="type == '4'">抄送我的</span>
      </div>
    </div>
    <div class="flow-list">
      <el-empty
        :image-size="200"
        v-if="!data.length && !searchData.length && !loading"
      ></el-empty>
      <el-card
        v-for="(item, index) in data.length ? data : searchData"
        :key="index"
        shadow="hover"
        class="my-card"
      >
        <div class="flow-item" @click="onClickFlow(item)">
          <div class="creator-info">
            <div class="">
              <div class="creator-avatar x-avatar avatar-image">
                <img
                  class="avatar-image"
                  :src="item.taskStartUserPhoto ? '/dfsFile/' + item.taskStartUserPhoto : logo"
                />
              </div>
              <div class="name">{{ item.taskStartUserName }}</div>
            </div>
          </div>
          <div class="state-info">
            <div class="entry-name" :show-overflow-tooltip="true">
              {{ item.taskTitle }}
            </div>
            <div>
              <el-tag class="tag" size="small" :type="getApprovalColor(item)">{{
                getApprovalStatusStr(item)
              }}</el-tag>
            </div>
          </div>
          <div class="form-info">
            <div class="flow-form-item">
              <div class="brief-label">当前审批人:</div>
              <div class="brief-val">
                <span>{{
                  item.assigneeName && item.assigneeName != 'null'
                    ? item.assigneeName.split(' ').join(',') + ''
                    : '--'
                }}</span>
              </div>
              <div class="brief-val" v-if="item.activeTaskList">
                <span v-if="item.activeTaskList[0].assignee">{{
                  item.activeTaskList[0].assigneeName
                }}</span>
                <!--或签的可选人-->
                <div
                  class="brief-val"
                  v-else-if="
                    item.activeTaskList[0].candidateUsers &&
                    item.activeTaskList[0].candidateUsers.length > 0
                  "
                >
                  <span v-for="cu in item.activeTaskList[0].candidateUsers">
                    {{ cu.psnName }}
                  </span>
                </div>
              </div>
            </div>
            <div class="flow-form-item">
              <div class="brief-label">当前节点:</div>
              <div class="brief-val" v-if="item.activeTaskList">
                {{ item.activeTaskList[0].name }}
              </div>
              <div class="brief-val">{{ item.nowTaskName || '--' }}</div>
            </div>
            <div class="flow-form-item">
              <div class="brief-label">时效:</div>
              <div class="brief-val" v-if="item.activeTaskList">
                {{ item.activeTaskList[0].dueDate }}
              </div>
              <div v-else>--</div>
            </div>
          </div>
          <div class="form-info">
            <template v-if="item.formInfo">
              <template v-for="(value, index) in item.formInfo">
                <div
                  class="flow-form-item"
                  :key="index"
                >
                  <div class="brief-label">{{ index }}:</div>
                  <div class="brief-val">{{ value !== 'null' ? value : '' }}</div>
                </div>
              </template>
            </template>
            <div class="time">
              <div v-if="type == '3'" class="flow-form-item">
                <div class="brief-label">处理时间:</div>
                <div class="brief-val">
                  <span>{{ getMyHandleTime(item.handledUser) }}</span>
                  <!-- <span>{{ item.taskCreateTime.replace(/\//g,'-') }}</span> -->
                </div>
              </div>
              <div v-else-if="!data.length && type != '3'" class="flow-form-item">
                <div class="brief-label">提交时间:</div>
                <div class="brief-val">
                  <span>{{ item.taskCreateTime.replace(/\//g, '-') }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-card>
    </div>
    <!-- 分页插件 -->
    <div class="flex-row flex-center" style="padding-bottom: 50px;">
      <el-pagination
        background
        size="mini"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[10, 30, 50, 100]"
        :page-size.sync="queryParams.size"
        :total="totalCount"
        :current-page.sync="queryParams.page"
        @current-change="getDataList"
        @size-change="getDataList"
        v-if="showpage"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import bpmApi from '@/api/activityBPM/index'
import GlobalSearch from '../common/GlobalSearch'
import * as globalSearchApi from '../../api/globalSearch'
import { formatDate } from '@/util/formatUtil'
import logo from '@/assets/logo.png'

export default {
  name: 'flow',
  components: {
    GlobalSearch
  },
  data() {
    return {
      logo,
      data: [],
      queryParams: {
        page: 1,
        size: 10,
        params: {
          procDefKeyList: [],
          procDefKey: '', //流程key
          // startUser:"",//发起者
          startTime1: '', //开始时间1
          startTime2: '', //开始时间2
          endTime1: '', //结束时间1
          endTime2: '' //结束时间2
        }
      },
      type: '1', //1待办： 2我发起的， 3我处理的， 4抄送我的
      activeIndex: this.$route.path,
      keyList: [],
      loading: false,
      totalCount: 0, //总数据量
      prodefList: [], //定义流程列表
      visible: false,
      getStorage: false, //是否从缓存中拿去参数
      showpage: true,
      searchValue: '',
      searchData: []
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.user || {}
    }
  },

  beforeRouteEnter(to, from, next) {
    // 来自表单，需要从session中拿参数还原页面
    next((vm) => {
      if (from.name === 'ddFlow' && vm.$route.query.isMenu === undefined) {
        vm.getStorage = true
      }
    })
  },
  mounted() {
    let type = this.$route.query.type
    if (type) {
      this.type = type
    }
    this.keyList = this.$store.state.process.keyList
    if (this.getStorage) {
      //从 localStorage 中那参数还原跳转到表单前的状态
      this.queryParams = JSON.parse(sessionStorage.getItem('queryParams'))
      this.$refs.child.params = JSON.parse(sessionStorage.getItem('globalParams'))
      this.$refs.child.commitTime1 = JSON.parse(sessionStorage.getItem('commitTime1'))
      this.$refs.child.commitTime2 = JSON.parse(sessionStorage.getItem('commitTime2'))
      this.$refs.child.performTime1 = JSON.parse(sessionStorage.getItem('performTime1'))
      this.$refs.child.performTime2 = JSON.parse(sessionStorage.getItem('performTime2'))
      this.showpage = false
      this.$nextTick(() => {
        this.showpage = true
      })
      this.getStorage = false
    }
    this.$nextTick(() => {
      if (this.type == '1') {
        this.$refs.child.getData('getMyHandling')
        this.searchValue = 'getMyHandling'
      } else if (this.type == '2') {
        this.$refs.child.getData('getMyStart')
        this.searchValue = 'getMyStart'
      } else if (this.type == '3') {
        this.$refs.child.getData('getMyHandled')
        this.searchValue = 'getMyHandled'
      } else if (this.type == '4') {
        this.$refs.child.getData('getMySend')
        this.searchValue = 'getMySend'
      }
    })
  },
  methods: {
    onClickFlow(item) {
      sessionStorage.setItem('queryParams', JSON.stringify(this.queryParams))
      if (item.procExtends) {
        this.$router.push({
          path:
            '/ddFlow?funCode=' + item.procExtends.funCode + '&id=' + item.businessKey
        })
      } else {
        sessionStorage.setItem('globalParams', JSON.stringify(this.$refs.child.params))
        sessionStorage.setItem(
          'commitTime1',
          JSON.stringify(this.$refs.child.commitTime1)
        )
        sessionStorage.setItem(
          'commitTime2',
          JSON.stringify(this.$refs.child.commitTime2)
        )
        sessionStorage.setItem(
          'performTime1',
          JSON.stringify(this.$refs.child.performTime1)
        )
        sessionStorage.setItem(
          'performTime2',
          JSON.stringify(this.$refs.child.performTime2)
        )
        sessionStorage.setItem('size', JSON.stringify(this.$refs.child.size))
        sessionStorage.setItem('page', JSON.stringify(this.$refs.child.page))
        this.$router.push({
          path:
            '/ddFlow?funCode=' +
            item.funCode +
            '&id=' +
            item.id +
            '&keyword=' +
            this.$refs.child.params.keyWord
        })
      }
    },
    goPage(index, indexPath) {
      if (index.startsWith('/flow') && index.split('type=')[1]) {
        this.$router.push({
          path: '/flow',
          query: { type: index.split('type=')[1].substr(0, 1) }
        })
        window.location.reload(true)
      }
    },
    getDataList() {
      this.$nextTick(() => {
        if (this.$route.query.isMenu !== undefined) {
          this.$router.push({ query: { type: this.$route.query.type } })
        }
        //页数改变时获取数据
        if (this.type == '1') {
          this.$refs.child.getData('getMyHandling')
          this.searchValue = 'getMyHandling'
        } else if (this.type == '2') {
          this.$refs.child.getData('getMyStart')
          this.searchValue = 'getMyStart'
        } else if (this.type == '3') {
          this.$refs.child.getData('getMyHandled')
          this.searchValue = 'getMyHandled'
        } else if (this.type == '4') {
          this.$refs.child.getData('getMySend')
          this.searchValue = 'getMySend'
        }
      })
    },
    getprodefList() {
      bpmApi.procDef.listProcessByServiceName({ serviceName: 'oa' }).then((res) => {
        if (res.success) {
          this.prodefList = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    changeSelect(val) {
      this.queryParams.params.procDefKey = val?.toLowerCase()
    },
    getApprovalColor(item) {
      if (item.status) {
        if (item.status == 2) {
          if (item.approvalStatus == 'APPROVAL' || item.approvalStatus == 'DISAGREE') {
            return 'success'
          } else if (item.approvalStatus == 'REJECT') {
            return 'danger'
          }
        } else if (item.status == 3 && item.approvalStatus == 'REVOKE') {
          return 'danger'
        }
        return ''
      } else {
        const statusMap = new Map([
          ['APPROVAL', 'success'],
          ['DISAGREE', 'success'],
          ['REJECT', 'danger'],
          ['REVOKE', 'danger'],
          ['COMMIT', '']
        ])
        return item.nowTaskName ? '' : statusMap.get(item.taskStatus)
      }
    },
    getApprovalStatusStr(item) {
      if (item.status) {
        if (item.status == 2) {
          if (item.approvalStatus == 'APPROVAL' || item.approvalStatus == 'DISAGREE') {
            return '审批通过'
          } else if (item.approvalStatus == 'REJECT') {
            return '被驳回'
          } else {
            return '已结束'
          }
        } else if (item.status == 3 && item.approvalStatus == 'REVOKE') {
          return '已撤回'
        } else {
          return '审批中'
        }
      } else {
        const statusMap = new Map([
          ['APPROVAL', '审批通过'],
          ['DISAGREE', '审批通过'],
          ['REJECT', '被驳回'],
          ['REVOKE', '已撤回'],
          ['COMMIT', '审批中'],
          ['RECALL', '审批中']
        ])
        var flowStatus = item.nowTaskName ? '审批中' : statusMap.get(item.taskStatus)
        return item.taskEndTime && flowStatus === '审批中' ? '已结束' : flowStatus
      }
    },
    getMyHandleTime(handel) {
      // 获取处理时间
      if (handel && handel.length > 0) {
        let myHandle = handel.filter((obj) => {
          return obj.psnCode == this.userInfo.psnCode
        })
        if (myHandle && myHandle.length > 0) {
          let han = myHandle[myHandle.length - 1] //取最后一条记录
          return formatDate(new Date(han.taskEndTime), 'yyyy-MM-dd HH:mm:ss')
        } else {
          return ''
        }
      } else {
        return '/'
      }
    },
    getStatus(statusQueryParams) {
      globalSearchApi.getStartStatus(statusQueryParams).then((res) => {
        if (res.success) {
          if (res.data) {
            res.data.map((item, index) => {
              this.$set(this.searchData[index], 'isWarn', item.isWarn)
              this.$set(this.searchData[index], 'overTime', item.overTime)
              this.$set(this.searchData[index], 'warnTime', item.warnTime)
            })
          }
        }
      })
      this.loading = false
    }
  }
}
</script>
<style>
.my-card .el-card__body {
  padding: 10px !important;
}
</style>
<style lang="scss" scoped>
.el-menu-demo {
  display: block;
  position: fixed;
  top: 0;
  width: 100vw;
  padding-left: 20px;
  z-index: 200;
}

.flow-wk {
  margin-top: 60px;
}

.params-panel {
  padding: 10px 20px;
  height: 30px;
  line-height: 30px;
  background-color: #f6f6f6;
  margin-bottom: 10px;
}

.flow-title {
  float: left;
}

.params-title {
  float: right;
}

.flow-list {
  padding: 0 20px;
  box-sizing: border-box;
  max-width: 1200px;
  min-width: 800px;
  margin: auto;
}

.my-card {
  margin-bottom: 10px;
}

.flow-item {
  justify-content: space-around;
  min-height: 80px;
  display: flex;
  align-items: center;
  .entry-name{
    padding-bottom: 10px;
    font-size: 14px;
  }
  .form-info{
    &:last-child{
      min-width: 35%;
      max-width: 35%;
    }
  }
}

.flow-item .creator-info {
  width: 50px;
  font-size: 13px;
  text-align: center;
  .name{
    padding-top: 5px;
  }
}

.flow-item .state-info {
  margin: 0 0 0 20px;
  justify-content: space-around;
  flex: 1 1 auto;
}

.flow-item .form-info {
  justify-content: space-around;
  min-width: 25%;
  max-width: 25%;
  padding-left: 10px;
  flex-shrink: 0;
}

.flow-item .form-info-detail {
  justify-content: space-around;
}

.flow-item .time {
  justify-content: space-around;
  //width: 10%;
  flex-shrink: 0;
}

.time .flex-col {
  flex: 1;
  font-size: 13px;
  text-align: right;
}

.flow-item .creator-info .creator-avatar {
  margin: 0 10px 0 5px;
}

.flow-item .creator-info .avatar-image {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.flow-form-item {
  font-size: 13px;
  display: flex;
  align-items: center;
  padding-bottom: 5px;
  > div{
    &:first-child{
      padding-right: 5px;
    }
  }
}

.flow-form-item .brief-label {
  display: inline-block;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #91a1b7;
  vertical-align: top;
  flex: none;
}

.flow-form-item .brief-val {
  flex: auto;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 280px;
}

/* @media screen and (max-width: 1202px) {
  .tag {
    margin-left: 10%;
  }
} */
@media screen and (max-width: 1202px) {
  .entry-name {
    font-size: 5px;
  }
}
</style>
